"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedAssetRequestToJSON = exports.LinkedAssetRequestFromJSONTyped = exports.LinkedAssetRequestFromJSON = exports.instanceOfLinkedAssetRequest = exports.LinkedAssetRequestTypeEnum = void 0;
var runtime_1 = require("../runtime");
var AssetType1_1 = require("./AssetType1");
/**
 * @export
 */
exports.LinkedAssetRequestTypeEnum = {
    SurveyAsset: 'SURVEY_ASSET',
    LinkedAsset: 'LINKED_ASSET'
};
/**
 * Check if a given object implements the LinkedAssetRequest interface.
 */
function instanceOfLinkedAssetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
exports.instanceOfLinkedAssetRequest = instanceOfLinkedAssetRequest;
function LinkedAssetRequestFromJSON(json) {
    return LinkedAssetRequestFromJSONTyped(json, false);
}
exports.LinkedAssetRequestFromJSON = LinkedAssetRequestFromJSON;
function LinkedAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'assetType': !(0, runtime_1.exists)(json, 'asset_type') ? undefined : (0, AssetType1_1.AssetType1FromJSON)(json['asset_type']),
        'linkedAssetId': !(0, runtime_1.exists)(json, 'linked_asset_id') ? undefined : json['linked_asset_id'],
    };
}
exports.LinkedAssetRequestFromJSONTyped = LinkedAssetRequestFromJSONTyped;
function LinkedAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'asset_type': (0, AssetType1_1.AssetType1ToJSON)(value.assetType),
        'linked_asset_id': value.linkedAssetId,
    };
}
exports.LinkedAssetRequestToJSON = LinkedAssetRequestToJSON;
